import type { ChangeEvent } from 'react';
import { ChevronDown } from 'lucide-react';
import { STRINGS } from '@/strings/strings';

export type StoryDuration = 'short' | 'standard' | 'long';

interface StorydurationSelectorProps {
  value: StoryDuration;
  onChange: (value: StoryDuration) => void;
  id?: string;
}

export function StorydurationSelector({ value, onChange, id }: StorydurationSelectorProps) {
  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value as StoryDuration);
  };

  return (
    <div className="relative">
      <select
        id={id}
        value={value}
        onChange={handleChange}
        className="builder-field h-11 w-full appearance-none px-3 pr-10 text-base text-dream-navy outline-none"
      >
        <option value="short">{STRINGS.builder.shared.storydurationShort}</option>
        <option value="standard">{STRINGS.builder.shared.storydurationDefault}</option>
        <option value="long">{STRINGS.builder.shared.storydurationLong}</option>
      </select>
      <ChevronDown
        aria-hidden
        className="pointer-events-none absolute top-1/2 right-3 h-4 w-4 -translate-y-1/2 text-dream-navy"
      />
    </div>
  );
}
